export const LeaveSectionData = {
    countries: [
      {
        country: "South Africa",
        section: "Leave",
        details: {
          annual_leave: {
            description: "A full-time employee in South Africa is entitled to 21 consecutive days (15 working days) of paid annual leave; this is the minimum mandatory leave entitlement.",
            accrual_rate: "The employee can accrue paid annual leave monthly at the rate of 1.25 days per month (1 day for every 17 days worked).",
            carry_over: "Unused leave carries over into the next year.",
          },
          public_holidays: {
            description: "When a public holiday falls on a Sunday, the following Monday shall be a public holiday in lieu.",
            holidays: [
              { date: "1 Jan 2024", day: "Monday", holiday: "New Year’s Day" },
              { date: "21 Mar 2024", day: "Thursday", holiday: "Human Rights Day" },
              { date: "29 Mar 2024", day: "Friday", holiday: "Good Friday" },
            ],
          },
          sick_leave: {
            description: "Sick leave is paid at 100% pay of the employee’s regular salary rate and granted on a three-year cycle of 30 sick days for a 5-day working week and 36 sick days for a 6-day working week.",
            accrual_rate: "During the first 6 months of employment, the employee accrues only 1 day of paid sick leave for every 26 days worked.",
            full_entitlement: "From the seventh month of employment, the full entitlement is granted to the employee.",
          },
        },
      },
      {
        country: "India",
        section: "Leave",
        details: {
          annual_leave: {
            description: "Employees in India are entitled to 15 days of annual leave per year after completing one year of service.",
            accrual_rate: "Employees accrue 1.25 days of leave for every month worked.",
            carry_over: "Leave can be carried forward to the next year, with a maximum accumulation of 30 days.",
          },
          public_holidays: {
            description: "India has both national and regional public holidays, varying by state.",
            holidays: [
              { date: "26 Jan 2024", day: "Friday", holiday: "Republic Day" },
              { date: "15 Aug 2024", day: "Thursday", holiday: "Independence Day" },
              { date: "2 Oct 2024", day: "Wednesday", holiday: "Gandhi Jayanti" },
            ],
          },
          sick_leave: {
            description: "Employees in India are entitled to 12 days of paid sick leave per year.",
            accrual_rate: "Sick leave is accrued monthly at the rate of 1 day per month worked.",
          },
        },
      },
      {
        country: "USA",
        section: "Leave",
        details: {
          annual_leave: {
            description: "There is no statutory minimum paid vacation in the United States; leave policies are determined by the employer.",
            accrual_rate: "Typically, employers provide 10-20 days of paid leave per year based on tenure.",
            carry_over: "Carry-over policies vary by employer.",
          },
          public_holidays: {
            description: "Federal holidays in the United States are observed nationwide.",
            holidays: [
              { date: "1 Jan 2024", day: "Monday", holiday: "New Year’s Day" },
              { date: "4 Jul 2024", day: "Thursday", holiday: "Independence Day" },
              { date: "25 Dec 2024", day: "Wednesday", holiday: "Christmas Day" },
            ],
          },
          sick_leave: {
            description: "There is no federal mandate for paid sick leave; policies vary by state and employer.",
            accrual_rate: "Some states require paid sick leave, typically accruing at 1 hour per 30 hours worked.",
          },
        },
      },
    ],
  };
  